<template>
  <el-dialog
      :visible.sync="visible"
      :close-on-click-modal="false"
      top="5px"
      class="dialog-big"
      @close="closeForm">
    <div slot="title">
      <span class="el-dialog__title">
        <b>{{ $t('common.parts') }}</b>
        - {{ currentProduct.description | capitalize }}
        - {{ device.mac_address || device.device_id }}
      </span>
    </div>
    <div v-loading="submitting">
      <el-steps
          :active="active"
          finish-status="success"
          align-center>
        <el-step
            title="Customer"
            description="Details" />
        <el-step
            title="Parts"
            description="Details" />
        <el-step
            title="Extra"
            description="Information" />
        <el-step
            title="Review"
            description="Before submit" />
        <el-step
            title="Summary"
            description="request" />
      </el-steps>
      <div class="step-content">
        <div v-if="active === 0">
          <customer-request-customer-step
              v-if="visible"
              ref="customerStep"
              :device="device"
              @next="nextStep(1)" />
        </div>
        <div v-if="active === 1">
          <customer-request-part-reasons-step
              :device="device"
              @back="backStep(0)"
              @next="nextStep(2)" />
        </div>
        <div v-if="active === 2">
          <customer-request-misc-step
              :device="device"
              @back="backStep(1)"
              @next="nextStep(3)" />
        </div>
        <div v-if="active === 3">
          <customer-request-review-step
              @back="backStep(2)"
              @submit="submit()" />
        </div>
        <div v-if="active === 4">
          <el-row :gutter="20">
            <el-col :span="12">
              <h4 class="request-panel-title">
                Request
              </h4>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="8">
                  <b>Request ID</b>
                </el-col>
                <el-col :span="16">
                  {{ newRequest.uuid }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="8">
                  <b>State</b>
                </el-col>
                <el-col :span="16">
                  {{ newRequest.state }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="8">
                  <b>Product</b>
                </el-col>
                <el-col :span="16">
                  {{ newRequest.old_product.description }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="8">
                  <b>Agent</b>
                </el-col>
                <el-col :span="16">
                  {{ newRequest.agent.email }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="8">
                  <b>Parts</b>
                </el-col>
                <el-col :span="16">
                  <ul class="reasons-resume">
                    <li
                        v-for="rr in newRequest.request_reasons"
                        :key="rr.reason.table.reason_id"
                        class="reason-row">
                      {{ rr.reason.table.text | capitalize }}
                      <div class="total-parts">
                        Total: {{ rr.quantity }}
                      </div>
                    </li>
                  </ul>
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="8">
                  <b>Created</b>
                </el-col>
                <el-col :span="16">
                  <time-zone-formatter :current-time="newRequest.created_at" />
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <h4 class="request-panel-title">
                Customer
              </h4>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="8">
                  <b>Name</b>
                </el-col>
                <el-col :span="16">
                  {{ newRequest.customer_name }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="8">
                  <b>Email</b>
                </el-col>
                <el-col :span="16">
                  {{ newRequest.customer_email }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="8">
                  <b>Phone</b>
                </el-col>
                <el-col :span="16">
                  {{ newRequest.customer_phone }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="8">
                  <b>Address</b>
                </el-col>
                <el-col :span="16">
                  {{ newRequest.customer_address_1 }},
                  <span v-if="newRequest.customer_address_2">{{ newRequest.customer_address_2 }},</span>
                  {{ newRequest.customer_city }}
                  <br>
                  {{ newRequest.customer_zip }},
                  {{ newRequest.customer_state }},
                  {{ newRequest.customer_country }}
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <div class="center-buttons">
            <el-button
                type="success"
                @click="closeForm()">
              Finish
            </el-button>
            <el-button
                type="primary"
                @click="showCopyModal()">
              Copy Request Information
            </el-button>
          </div>
          <CustomerRequestCopyData
              ref="copyRequestModal"
              :request="newRequest" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { get, extend } from "lodash";
import CustomerRequestCustomerStep from "./CustomerRequestComponents/CustomerRequestCustomerStep";
import CustomerRequestPartReasonsStep from "./CustomerRequestComponents/CustomerRequestPartReasonsStep";
import CustomerRequestMiscStep from "./CustomerRequestComponents/CustomerRequestMiscStep";
import CustomerRequestReviewStep from "./CustomerRequestComponents/CustomerRequestReviewStep";
import CustomerRequestCopyData from "./CustomerRequestComponents/CustomerRequestCopy";

import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: authGetters } = h("auth");
const { mapGetters: sharedGetters } = h("shared");
const { mapActions: requestActions, mapGetters: requestGetters } =
  h("db/requests");

export default {
  name: "ReplacementModalForm",
  components: {
    CustomerRequestCustomerStep,
    CustomerRequestMiscStep,
    CustomerRequestReviewStep,
    CustomerRequestPartReasonsStep,
    CustomerRequestCopyData,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    device: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      active: 0,
      submitting: false,
      visible: false,
      newRequest: {
        old_device: this.device,
        agent: {},
        reasons: [],
      },
      request: {
        type: "parts",
        requester: null,
      },
      oowBypassReason: null,
    };
  },
  computed: {
    ...authGetters(["user"]),
    ...requestGetters(["requestInProgress"]),
    ...sharedGetters(["products"]),
    currentKind() {
      return this.device.type || this.device.kind || this.device.profile.kind;
    },
    currentProduct() {
      return (
        this.products.find((p) => p.kind === this.currentKind) || {
          description: `${this.currentKind} not found in Admin`,
        }
      );
    },
  },
  methods: {
    ...requestActions([
      "createRequest",
      "resetRequestInProgress",
      "setGeneralData",
      "setCustomerInformation",
      "setAddressInformation",
      "setProductInformation",
      "setReasonInformation",
      "setMiscInformation",
    ]),
    closeForm() {
      this.visible = false;
      this.resetRequestInProgress();
      this.active = 0;
      this.$emit("closed-form");
    },
    openForm(oowBypassReason = null) {
      this.visible = true;
      this.parseDataFromStore();
      this.oowBypassReason = oowBypassReason;
    },
    parseDataFromStore() {
      this.request.requester = this.user;
      let profileId = get(this.device, "profile.id", "");
      this.setGeneralData({
        profile: {
          id: profileId,
          deviceId: get(this.device, "profile.device_id", ""),
          kind: get(this.device, "profile.kind", ""),
        },
        requester: this.request.requester,
        type: this.request.type,
      });
    },
    nextStep(step) {
      this.active = step || this.active + 1;
    },
    backStep(step) {
      this.active = step || this.active - 1;
    },
    showCopyModal() {
      this.$refs.copyRequestModal.openModal();
    },
    submit() {
      this.submitting = true;
      let payload = this.createPayload();
      this.createRequest(payload)
        .then((response) => {
          this.newRequest = response.data;
          this.submitting = false;
          this.nextStep(4);
        })
        .catch((error) => {
          this.$forEachPlcError(error, (msg) => {
            this.$notify({ type: "error", message: msg });
          });
          this.submitting = false;
          this.done = false;
        });
    },
    createPayload() {
      let temp = {};
      let kind =
        this.device.type ||
        this.device.kind ||
        this.requestInProgress.general.profile.kind;

      extend(temp, {
        device_kind: kind,
        profile_id: this.requestInProgress.general.profile.id,
      });
      extend(temp, this.requestInProgress.customer);
      extend(temp, this.requestInProgress.address);
      extend(temp, this.requestInProgress.misc);
      extend(temp, this.requestInProgress.product);
      extend(temp, {
        customer_request_reasons_attributes:
          this.requestInProgress.reasons.reasons.map((reason) => {
            return {
              reason_id: reason.id,
              quantity: reason.quantity,
            };
          }),
      });
      extend(temp, {
        type: "CustomerRequest::Part",
        admin_user_id: this.user.id,
        requested_by_area: "customer_support",
      });

      if (this.oowBypassReason) {
        extend(temp, { oow_bypass_reason: this.oowBypassReason });
      }

      return temp;
    },
  },
};
</script>

<style>
.total-parts {
  float: right;
  color: red;
}
</style>
